import { Component } from '@angular/core';
import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IHeaderParams } from 'ag-grid-community';

@Component({
  selector: 'pt-progress-formatter-renderer',
  template: `<span>{{params.value | number }}%</span>`,
  styles: [``]
})
export class ProgressFormatterRendererComponent implements ICellRendererAngularComp, IHeaderAngularComp {

  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean;
  refresh(params: IHeaderParams): boolean;
  refresh(params: ICellRendererParams | IHeaderParams): boolean {
    return false;
  }

}
